import axios from 'axios'
import shortly from 'vuex-shortly'
import { BRANDS } from '@store/types'

const state = {
  brands: []
}

const getters = {
  [BRANDS]: 'brands'
}

const mutations = {
  [BRANDS]: 'brands'
}

const actions = {
  [BRANDS]: async ({ commit }) => {
    const response = await axios.get('/brands')
    commit(BRANDS, response.data.data)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/brands.js